/**
 * true apenas em npm start / development acessando localhost ou 127.0.0.1.
 * Usado para relaxar validações de etapas durante testes locais.
 */
export function isLocalhostDev() {
  if (process.env.NODE_ENV !== "development") return false;
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}
